import { getDefaultClient } from '@dynamic-labs-sdk/client';
import { getWalletProviderFromWalletAccount } from '@dynamic-labs-sdk/client/core';

import type { BitcoinWalletAccount } from '../BitcoinWalletAccount.types';
import type { BitcoinSignPsbtRequest } from '../BitcoinWalletProvider.types';
import { NotBitcoinProviderError } from '../errors/NotBitcoinProviderError';
import { isBitcoinWalletProvider } from '../isBitcoinWalletProvider';

type SignPsbtParams = {
  request: BitcoinSignPsbtRequest;
  walletAccount: BitcoinWalletAccount;
};

/**
 * Signs a PSBT
 * @param params.request - The request data to sign the PSBT
 * @param params.walletAccount - The wallet account to sign the PSBT with
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns An object containing the signed PSBT
 */
export const signPsbt = async (
  { walletAccount, request }: SignPsbtParams,
  client = getDefaultClient()
): Promise<{ signedPsbt: string }> => {
  const provider = getWalletProviderFromWalletAccount(
    {
      walletAccount,
    },
    client
  );

  if (!isBitcoinWalletProvider(provider)) {
    throw new NotBitcoinProviderError({ providerKey: provider.key });
  }

  return provider.signPsbt({ request, walletAccount });
};
